/** Topbar appearance picker: Light / Dark / Match system. */
import { Menu } from './ui';
import { Icon } from './icons';
import { useTheme, type ThemePreference } from './ThemeProvider';

const LABEL: Record<ThemePreference, string> = { light: 'Light', dark: 'Dark', system: 'Match system' };

export function ThemeToggle() {
  const { theme, resolved, setTheme } = useTheme();
  const Glyph = resolved === 'dark' ? Icon.Moon : Icon.Sun;

  return (
    <Menu
      label="Appearance"
      items={(['light', 'dark', 'system'] as const).map((t) => ({
        key: t,
        label: LABEL[t],
        icon: t === 'light' ? ('Sun' as const) : t === 'dark' ? ('Moon' as const) : ('Monitor' as const),
        checked: theme === t,
        onSelect: () => setTheme(t),
      }))}
      trigger={({ toggle, ref, open }) => (
        <button
          ref={ref}
          type="button"
          className="icon-btn has-tip"
          onClick={toggle}
          aria-haspopup="menu"
          aria-expanded={open}
          aria-label={`Appearance: ${LABEL[theme]}`}
          data-tip="Appearance"
        >
          <Glyph aria-hidden />
        </button>
      )}
    />
  );
}
